import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import prmLogo from '_assets/images/gateway/prm-logo.png';

const navLinkStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 7,
  padding: '10px 16px',
  borderRadius: 10,
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: '.04em',
  textTransform: 'uppercase',
  color: '#1c2b4a',
  minHeight: 44,
};

const GatewayHeader = () => {
  // In-page anchor links (#audience, #footer) should scroll smoothly while any
  // gateway page is mounted, without affecting scroll behaviour elsewhere in the app.
  useEffect(() => {
    const prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => { document.documentElement.style.scrollBehavior = prev; };
  }, []);

  return (
    <>
      <a href="#main" className="gw-skip-link" style={{ position: 'absolute', left: -9999, top: 12, background: '#1c2b4a', color: '#fff', padding: '12px 18px', borderRadius: 8, zIndex: 100, fontSize: 14, fontWeight: 600 }}>
        Skip to content
      </a>

      <header style={{ position: 'sticky', top: 0, zIndex: 50, background: 'rgba(255,255,255,0.88)', backdropFilter: 'saturate(180%) blur(14px)', borderBottom: '1px solid rgba(32,138,239,0.18)' }}>
        <div style={{ maxWidth: 1240, margin: '0 auto', padding: '0 32px', height: 76, display: 'flex', alignItems: 'center', gap: 32 }}>
          <Link to="/" aria-label="PRM Assist home" style={{ display: 'flex', alignItems: 'center' }}>
            <img src={prmLogo} alt="PRM Assist" style={{ height: 34, width: 'auto', display: 'block' }} />
          </Link>
          <nav aria-label="Primary" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 4 }}>
            <span id="gw-nav-links" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <Link to="/passengers" className="gw-nav-link" style={navLinkStyle}>Passengers</Link>
              <Link to={{ pathname: '/', hash: '#audience' }} className="gw-nav-link" style={navLinkStyle}>Aviation teams</Link>
              <Link to={{ pathname: '/', hash: '#footer' }} className="gw-nav-link" style={navLinkStyle}>Company</Link>
              <a href="https://prmassist.com/login" className="gw-nav-link" style={navLinkStyle}>Portal Login</a>
            </span>
            <Link to="/request-demo" style={{ marginLeft: 12, display: 'flex', alignItems: 'center', gap: 10, minHeight: 44, padding: '12px 22px', borderRadius: 10, background: '#1670c8', color: '#fff', fontSize: 14, fontWeight: 700, letterSpacing: '.04em', textTransform: 'uppercase', boxShadow: '0 6px 16px rgba(32,138,239,0.28)' }}>
              Book a demo
            </Link>
          </nav>
        </div>
      </header>
    </>
  );
};

export default GatewayHeader;
